import { useRef } from 'react'

export const useAsyncConfirmation = () => {
  const isConfirmedRef = useRef(false)

  const onConfirming = () => {
    isConfirmedRef.current = false
    return new Promise((resolve) => {
      const checkConfirm = () => {
        setTimeout(() => {
          if (isConfirmedRef.current) {
            resolve(true)
          } else {
            checkConfirm()
          }
        }, 10)
      }
      checkConfirm()
    })
  }

  const confirm = () => {
    isConfirmedRef.current = true
  }
  return { onConfirming, confirm }
}
